export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN || "https://kpi-api.pascallsystems.com";

export const AUTH_API = `${API_DOMAIN}/auth`;
export const VERIFY_CURRENT_SESSION_API = `${AUTH_API}/current-session`;
export const LOG_IN_API = `${AUTH_API}/login`;
export const MS_LOG_IN_API = `${AUTH_API}/login/microsoft`;
export const LOG_OUT_API = `${AUTH_API}/logout`;

export const USERS_API = `${API_DOMAIN}/user`;
export const ASSIGNED_API = `${API_DOMAIN}/assigned`;
export const GET_ALL_DOCUMENTS_API = `${API_DOMAIN}/documents`;

export const GET_MENU_ITEMS = `${API_DOMAIN}/menu`;
export const GET_CONFLUENCE_PAGES = `${API_DOMAIN}/pages`;

export const SOP_REVIEW_API = `${API_DOMAIN}/sop-review`;
export const GET_SOPS_DOCUMENT = `${SOP_REVIEW_API}/sop-documents`;
export const UPDATE_SOP_REVIEW_STATUS_API = `${SOP_REVIEW_API}/update-sop-review-status`;

export const TRAINING_MANAGEMENT_API = `${API_DOMAIN}/training-management`;
export const GET_TRAINING_RECORDS_API = `${TRAINING_MANAGEMENT_API}/training-records`;
export const UPDATE_TRC_STATUS_API = `${TRAINING_MANAGEMENT_API}/update-trc-status`;
export const DELETE_TRC_API = `${TRAINING_MANAGEMENT_API}/delete-trc`;
export const EXPORT_REPORT_TRC_API = `${TRAINING_MANAGEMENT_API}/export-report`;

export const CAPA_MANAGEMENT_API = `${API_DOMAIN}/capa-management`;
export const GET_CAPA_DATA_API = `${CAPA_MANAGEMENT_API}/capa-data`;
export const UPDATE_CAPA_STATUS_API = `${CAPA_MANAGEMENT_API}/update-capa-status`;

export const PURCHASE_ACCEPTANCE_API = `${API_DOMAIN}/purchase-acceptance`;
export const GET_PURCHASE_ACCEPTANCE_DATA_API = `${PURCHASE_ACCEPTANCE_API}/purchase-acceptance-data`;
export const UPDATE_PURCHASE_ACCEPTANCE_STATUS_API = `${PURCHASE_ACCEPTANCE_API}/update-grn-status`;

export const NONCONFORMANCE_AND_INVESTIGATION_API = `${API_DOMAIN}/nonconformance-and-investigation`;
export const GET_NAI_KPI_DATA_API = `${NONCONFORMANCE_AND_INVESTIGATION_API}/nai-kpi-data`;

export const INTERNAL_AUDIT_API = `${API_DOMAIN}/internal-audit`;
export const GET_INTERNAL_AUDIT_DATA_API = `${INTERNAL_AUDIT_API}/internal-audit-kpi-data`;

export const MANAGEMENT_REVIEWS_API = `${API_DOMAIN}/management-reviews`;
export const GET_MANAGEMENT_REVIEWS_DATA_API = `${MANAGEMENT_REVIEWS_API}/management-reviews-kpi-data`;

export const DEVICE_MANAGEMENT_API = `${API_DOMAIN}/device-management`;
export const GET_DEVICE_MANAGEMENT_DATA = `${DEVICE_MANAGEMENT_API}/devices-kpi`;

export const NUMBER_OF_CREATED_AND_RESOLVED_API = `${API_DOMAIN}/number-of-created-and-resolved`;
export const GET_NUMBER_OF_CREATED_AND_RESOLVED_DATA_API = `${NUMBER_OF_CREATED_AND_RESOLVED_API}/number-of-created-and-resolved-kpi-data`;

// Training KPI (frontend feature; backend endpoints may be added separately)
export const TRAINING_KPI_API = `${API_DOMAIN}/training-kpi`;
export const TRAINING_KPI_EMPLOYEE_ROLLUP = `${TRAINING_KPI_API}/employee-rollup`;
export const TRAINING_KPI_UPDATE_DOCUMENT_CRITICALITY = `${TRAINING_KPI_API}/documents`;
export const TRAINING_KPI_UPDATE_ON_TIME_OVERRIDE = `${TRAINING_KPI_API}/assigned`;
